import { SpecialOffersUI } from "./SpecialOffersUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { hasSizes } from "../../utils/product/hasSizes";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";
import { removeIFCMessages } from "../../utils/product/interestFreeCredit/removeIFCMessages";
import { isDiorBrand } from "@JohnLewisPartnership/jl-design-system/dist/utils/brands/brands";

export function SpecialOffers({
  product,
  runtimeConfig,
  flags,
}: Pick<StandardProps, "product" | "runtimeConfig" | "flags">) {
  const router = useRouter();
  const sizeParam = getSizeQuery(router.query);
  const { variant } = useVariant(product);
  const productHasSizes = hasSizes(product);
  const isVariantExplicitlySelected = productHasSizes && sizeParam;
  const messages =
    (isVariantExplicitlySelected ? variant.messaging : product.messaging) || [];

  const specialOffersVariant = flags.specialOffersVariant.value;

  const cleanedMessages = removeIFCMessages(messages);

  const { brand } = product;
  const isBlackOverride = isDiorBrand(brand?.name);

  const prodCatEndpoint = runtimeConfig.prodcatEndpoint;
  const prodCatApiKey = runtimeConfig.prodcatApiKey;
  const basketEndpoint = runtimeConfig.basketApiBaseUrl;

  return (
    <SpecialOffersUI
      messages={cleanedMessages}
      isBlackOverride={isBlackOverride}
      prodCatEndpoint={prodCatEndpoint}
      prodCatApiKey={prodCatApiKey}
      basketEndpoint={basketEndpoint}
      specialOffersVariant={
        specialOffersVariant ? specialOffersVariant.toString() : undefined
      }
    />
  );
}
